import React from 'react'

const EcoLeafIcon = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.075 6.07709C-1.01999 10.1735 -1.01999 16.8058 3.045 20.9022C5.25 15.8004 9.17996 11.5389 14.0849 9.0031C9.93 12.5143 7.01996 17.421 6.00004 22.988C9.89996 24.8336 14.7 24.1584 17.925 20.9322C23.145 15.7104 24 0 24 0C24 0 8.29504 0.855295 3.075 6.07709Z" />
    </svg>
  )
}

export default EcoLeafIcon
